import React from 'react'
import { GlobalStatesProvider } from './GlobalStatesProviders'
import { CartContextProvider } from './CartProvider'

const AppProvider = ({ children, apiUrlState, recursosUrlState }) => {
  return (
    <GlobalStatesProvider
      apiUrlState={apiUrlState}
      recursosUrlState={recursosUrlState}
    >
      <CartContextProvider>
        {children}
      </CartContextProvider>
    </GlobalStatesProvider>
  )
}

export default AppProvider